__turbopack_context__.v({
  "container": "_6LjdHG_container",
  "heading": "_6LjdHG_heading",
});
